import { Datepicker } from "@mobiscroll/react";
import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import AsyncTypeahead from "../../../../components/AsyncTypeahead";
import { createPatientApi } from "../../../../api-helpers/PatientApiHelper";
import Toaster, { ToastConfig } from "../../../../components/Toaster";
import { ErrorTypes } from "../../../../interfaces/errors";
import { UpdateCommPreferences } from "patients-experience-client";
import { createCommonUtilsApi } from "../../../../api-helpers/CommonUtilsApiHelper";
import Lookups from "../../../../constants/Lookups";
import { Lookup } from "common-util-experience-client";
import Spinner from "../../../../components/Spinner";

export const EditCommunication = (props: any) => {
    const patientInfo = props.patientInfo;
    const [loading, setloading] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [validated, setValidated] = useState(false);
    const [languages, setLanguages] = useState<Lookup[]>([]);
    const commonUtilApi = createCommonUtilsApi();
    const patientApi = createPatientApi();
    const [toastConfig, setToastConfig] = useState<ToastConfig>({
        type: "success" as ErrorTypes,
        title: "",
        icon: "",
    });
    const patientId = patientInfo?.patientId
    const [form, setForm] = useState<UpdateCommPreferences>({
        preferredLanguageId: patientInfo?.preferredLanguageInfo?.id || "",
        preferredChatChannel: patientInfo?.preferredChatChannel || "",
        preferredCommChannel: patientInfo?.preferredCommunicationChannel || "",
    });

    useEffect(() => {
        loadLanguages();
    }, [])

    const loadLanguages = async () => {
        setLanguages([]);
        setloading(true);
        try {
            const response = await commonUtilApi.lookupControllerFindAll(Lookups.LANGUAGE_OPTIONS);
            setLanguages(response.data);
        } catch (error: any) {
            console.log(error);
        } finally {
            setloading(false);
        }
    };

    const submitHandler = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setValidated(true);

        const addForm = event.currentTarget;
        if (!addForm.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        setloading(true);
        try {
            await patientApi.patientsControllerUpdateCommPreferences(form, patientInfo.patientId);
            setloading(false);
            showSuccessMessage();
            setTimeout(() => {
                handleDiscard();
            }, 1500);
            props.loadPersonalDetails();
        } catch (error) {
            console.error(error);
            setloading(false);
            showErrorMessage();
        }
    };

    const showSuccessMessage = () => {
        setShowToast(false);
        const toasterConfig: ToastConfig = {
            type: "success",
            title: "Communication Preferences Updated Successfully",
            icon: "check_circle_outline",
        };
        setToastConfig(toasterConfig);
        setShowToast(true);
    }

    const showErrorMessage = () => {
        setShowToast(false);
        const toasterConfig: ToastConfig = {
            type: "danger",
            title: "Error while updating Communication Preferences!",
            icon: "error_outline",
        };
        setToastConfig(toasterConfig);
        setShowToast(true);
    }
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setForm({
            ...form,
            [name]: value
        });
    };
    const handleDiscard = () => {
        props.setOffCanvasShow(false);
    };
    return (
        <>
        { loading && <Spinner /> }
        <div className="row">
            <Toaster
                show={showToast}
                onClose={() => setShowToast(false)}
                type={toastConfig.type}
                title={toastConfig.title}
                message={toastConfig.message}
                icon={toastConfig.icon}
            />
        </div>
        <Form
            className="d-flex flex-column h-100"
            noValidate
            validated={validated}
            onSubmit={submitHandler}>
            <div className="flex-fill">
                <div className="row g-2 mb-3">
                    <div className="col-6">
                        <div className="mb-3">
                            <label
                                className="form-label fs-12 fw-semibold mb-1"
                            >
                                Language
                            </label>
                            <select
                                onChange={handleInputChange} required name="preferredLanguageId" className="form-select" value={ form.preferredLanguageId }
                            >
                                <option value="" selected>Select</option>
                                {
                                    languages.length && languages.map((lang: Lookup) => (
                                        <option key={lang.id}value={lang.id}>{lang.name}</option>
                                    ))
                                }
                            </select>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <label
                                className="form-label fs-12 fw-semibold mb-1"
                            >
                                Chat Via
                            </label>
                            <select
                                onChange={handleInputChange} name="preferredChatChannel" required
                                className="form-select" value={form.preferredChatChannel}
                            >
                                <option value="" selected>Select</option>
                                <option value="SMS">SMS</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="mb-3">
                            <label
                                className="form-label fs-12 fw-semibold mb-1"
                            >
                                Communication Channel
                            </label>
                            <select
                                onChange={handleInputChange} name="preferredCommChannel" required
                                className="form-select" value={form.preferredCommChannel}
                            >
                                <option value="" selected>Select</option>
                                <option value="Video">Video</option>
                                <option value="Audio">Audio</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div className="offcanvas-footer text-end w-100 border-top d-flex justify-content-between border-top">
                <div>
                    <button
                        className="btn btn-outline-secondary rounded-pill px-5 fs-13"
                        type="reset"
                        onClick={handleDiscard}
                    >
                        Discard
                    </button>
                </div>
                <div>
                    <button
                        className="btn btn-secondary rounded-pill ps-4 pe-5 fs-13"
                        type="submit"
                    >
                        Update
                    </button>
                </div>
            </div>
        </Form>
        </>
    );
};